// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__28F1i","row":"Node_row__3iHjZ","label":"Node_label__2WarH","footer":"Node_footer__1pPG0"};